/**
 * Language Redirection Script
 * Handles automatic language detection and redirection based on user preferences
 */
(() => {
  const currentPath = window.location.pathname;
  const currentLocale = document.documentElement.getAttribute('data-locale') || 'fr';
  const storedLanguage = localStorage.getItem('user-lang');
  const justSwitchedLanguage = sessionStorage.getItem('justSwitchedLanguage');

  // User explicitly switched languages via switcher - respect that choice
  if (justSwitchedLanguage) {
    sessionStorage.removeItem('justSwitchedLanguage');
    localStorage.setItem('user-lang', currentLocale);
  } else if (!storedLanguage) {
    // New user: check browser language and redirect if needed
    const isOnDutchPath = currentPath.includes('/nl/') || currentPath.startsWith('/nl');
    const browserLanguage = navigator.language || navigator.userLanguage;
    const isDutchBrowser = browserLanguage.toLowerCase().includes('nl');

    // Redirect Dutch browsers to Dutch version
    if (isDutchBrowser && !isOnDutchPath) {
      localStorage.setItem('user-lang', 'nl');
      setTimeout(() => {
        const newPath = currentPath === '/' ? '/nl/' : `/nl${currentPath}`;
        window.location.href = newPath;
      }, 10);
    } else {
      // Respect current URL and set language preference
      localStorage.setItem('user-lang', isOnDutchPath ? 'nl' : 'fr');
    }
  } else {
    // Returning user: sync stored preference with current path
    const isOnDutchPath = currentPath.includes('/nl/') || currentPath.startsWith('/nl');
    const isOnDefaultFrenchPath = !isOnDutchPath;

    if (isOnDutchPath && storedLanguage !== 'nl') {
      // User navigated to Dutch URL - update preference
      localStorage.setItem('user-lang', 'nl');
    } else if (storedLanguage === 'nl' && isOnDefaultFrenchPath) {
      // Dutch preference but on French path - redirect to Dutch
      setTimeout(() => {
        const newPath = currentPath === '/' ? '/nl/' : `/nl${currentPath}`;
        window.location.href = newPath;
      }, 10);
    } else if (storedLanguage === 'fr' && isOnDutchPath) {
      // French preference but on Dutch path - redirect to French
      setTimeout(() => {
        const newPath = currentPath.replace('/nl/', '/').replace('/nl', '/');
        const finalPath = newPath === '//' ? '/' : newPath;
        window.location.href = finalPath;
      }, 10);
    }
  }

  // Listen for language switcher clicks
  document.addEventListener('DOMContentLoaded', () => {
    const langList = document.querySelectorAll('.disclosure-list__option');
    langList.forEach((option) => {
      option.addEventListener('click', () => {
        sessionStorage.setItem('justSwitchedLanguage', 'true');
      });
    });
  });
})();
